(() => {
  'use strict';
  // AOV cart-goal assets are not active in this draft theme. The former
  // document-wide MutationObserver and attachShadow patch were removed.
  window.__tangibleDuplicateCartGoalsBlockerDisabled = true;
})();
